import { api_GETExternal } from "services/api_service.js";

export const GetCEPViaCEP = (cep) => {
    const promise = new Promise((resolve, reject) => {
        api_GETExternal(`https://viacep.com.br/ws/${cep.replace("-", "")}/json/`).then(result => {
            if (result.status !== 200 || (result.data.hasOwnProperty('erro') && result.data.erro == true)) {
                resolve(null);
            }
            else {
                resolve(result);
            }
        });
    });

    return promise;
}